import DashboardView from "./dashboard/DashboardView";
import Footer from "../layout/home/footer";
import { Stack } from "@mui/material";

export default function Home() {


  return (
    <Stack direction="column" sx={{ height: "100vh", width: "100%" }}>
        <DashboardView />
        <Footer />
    </Stack>  
  );
}
